// extracted by mini-css-extract-plugin
module.exports = {"container":"FundWallet_container__1_mP1"};